import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
// import 'lib-flexible'
import store from "./store";
import axios from "axios";
import VueAxios from "vue-axios";
import qs from "qs";
// 响应式通用样式
import "./assets/css/responsive.css";
import { flexible } from "./utils/flexible.js";
import websocket from "./utils/webSocket";
// css
import "./assets/css/public.css";
// 字体文件
import "./assets/css/fonts.css";
// 导入qiankun.js
import { registerMicroApps, setDefaultMountApp, start } from "qiankun";
import moment from "moment";
import utils from "./utils/auth.js";
import EventBus from "./utils/EventBus.js";
import { request, download } from "./api/index.js";
// 自定义组件-文本超出隐藏
import OverflowTxt from "./components/overflowTxt.vue";

// 将utils对象的方法添加到Vue的原型上
Object.keys(utils).forEach((key) => {
    Vue.prototype["$$" + key] = utils[key];
});

// 全局注册组件
Vue.component("overflow-txt", OverflowTxt);

const upmsDomain = process.env.VUE_APP_UPMS_DOMAIN;

// 注册子应用
registerMicroApps([
    {
        name: "vue app", // 子应用名称
        // entry: '//localhost:8081',  // 子应用入口
        entry: upmsDomain, // 子应用入口
        container: "#sub", // 子应用所在容器
        activeRule: "/vue", // 子应用触发规则（路径）
    },
]);

// 启动默认应用
// setDefaultMountApp('/vue')

// 开启服务
start({
    prefetch: true, // 取消预加载
});

// 公共变量
Vue.prototype.$websocket = websocket;
Vue.prototype.role = "";
Vue.prototype.userInfo = {};
Vue.prototype.$request = request;
Vue.prototype.$download = download;
Vue.config.productionTip = false;

Vue.use(ElementUI, VueAxios, axios);
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
var fontSize = 0;
var fontRem = 0;
// 获取 URL 参数
Vue.prototype.getQueryString = function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var href = window.location.href;
    href = decodeURI(href);
    var r = href.substr(href.indexOf("?") + 1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

var _this = new Vue();

EventBus.$on("sendMsg", (data) => {
    console.log("接收到 sendMsg");
    console.log(data);
    if (data.getFlag) {
    }
});

// 埋点方法
/**
 * {caseNo:'',eventId:'',extFlag:'',extStr:'',extType:'',extVal:''}
 * caseNo 案件号  string
 * eventId 事件ID  string
 * remark 事件备注 string
 * extFlag 拓展值-布尔  boolean
 * extStr 拓展值-字符串  string
 * extType 拓展值类型  string
 * extVal 拓展值数字  number
 */
Vue.prototype.dataCollection = (option) => {
    request({
        method: "post",
        url: "/ubi/api/tenant/userOperation",
        data: option,
    });
};

Vue.prototype.moment = moment;

//选择月份 前num个月的 不含当月
Vue.prototype.selectMonth = function (num, sign) {
    var nowDate = new Date();
    var year = nowDate.getFullYear();
    var month = nowDate.getMonth() + 1; //0-11表示1-12月
    var startMonth = "",
        endMonth = "";
    if (month - num <= 0) {
        startMonth =
            year - 1 + "-" + (12 - (num - month)).toString().padStart(2, "0");
    } else {
        startMonth = year + "-" + (month - num).toString().padStart(2, "0");
    }
    let _num = sign == "defalut" ? 0 : 1;
    if (month - 1 == 0) {
        endMonth =
            year - 1 + "-" + (12 - (_num - month)).toString().padStart(2, "0");
    } else {
        endMonth = year + "-" + (month - _num).toString().padStart(2, "0");
    }
    this.navForm.startTime = startMonth;
    this.navForm.endTime = endMonth;
};
//计算月份间隔  开始月份-结束月份
(Vue.prototype.calcMonthInterval = function (startTime, endTime) {
    let startYear = startTime.split("-")[0];
    let startMonth = parseInt(startTime.split("-")[1]);
    let endYear = endTime.split("-")[0];
    let endMonth = parseInt(endTime.split("-")[1]);
    if (endYear == startYear) {
        return endMonth - startMonth + 1;
    } else {
        let monthNum = 0;
        monthNum = (endYear - startYear) * 12 - startMonth + endMonth + 1;
        return monthNum;
    }
}),
    (Array.prototype.indexOf = function (val) {
        for (var i = 0; i < this.length; i++) {
            if (this[i] == val) return i;
        }
        return -1;
    });
Array.prototype.remove = function (val) {
    var index = this.indexOf(val);
    if (index > -1) {
        this.splice(index, 1);
    }
};
Vue.prototype.BMaptoAMap = function (lng, lat) {
    const X_PI = (Math.PI * 3000.0) / 180.0;
    let x = lng - 0.0065;
    let y = lat - 0.006;
    let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
    let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
    let amap_lng = z * Math.cos(theta);
    let amap_lat = z * Math.sin(theta);
    return {
        lng: amap_lng,
        lat: amap_lat,
    };
};
Vue.prototype.transformFromWGSToGCJ = function (latitude, longitude) {
    var lat = "";
    var lon = "";
    var ee = 0.00669342162296594323;
    var a = 6378245.0;
    var pi = 3.14159265358979324;
    var adjustLat = transformLatWithXY(longitude - 105.0, latitude - 35.0);
    var adjustLon = transformLonWithXY(longitude - 105.0, latitude - 35.0);
    var radLat = (latitude / 180.0) * pi;
    var magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    var sqrtMagic = Math.sqrt(magic);
    adjustLat =
        (adjustLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * pi);
    adjustLon = (adjustLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * pi);
    latitude = latitude + adjustLat;
    longitude = longitude + adjustLon;
    return { lat: latitude, lng: longitude };
};
function transformLatWithXY(x, y) {
    var pi = 3.14159265358979324;
    var lat =
        -100.0 +
        2.0 * x +
        3.0 * y +
        0.2 * y * y +
        0.1 * x * y +
        0.2 * Math.sqrt(Math.abs(x));
    lat +=
        ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) *
            2.0) /
        3.0;
    lat +=
        ((20.0 * Math.sin(y * pi) + 40.0 * Math.sin((y / 3.0) * pi)) * 2.0) /
        3.0;
    lat +=
        ((160.0 * Math.sin((y / 12.0) * pi) + 320 * Math.sin((y * pi) / 30.0)) *
            2.0) /
        3.0;
    return lat;
}

function transformLonWithXY(x, y) {
    var pi = 3.14159265358979324;
    var lon =
        300.0 +
        x +
        2.0 * y +
        0.1 * x * x +
        0.1 * x * y +
        0.1 * Math.sqrt(Math.abs(x));
    lon +=
        ((20.0 * Math.sin(6.0 * x * pi) + 20.0 * Math.sin(2.0 * x * pi)) *
            2.0) /
        3.0;
    lon +=
        ((20.0 * Math.sin(x * pi) + 40.0 * Math.sin((x / 3.0) * pi)) * 2.0) /
        3.0;
    lon +=
        ((150.0 * Math.sin((x / 12.0) * pi) +
            300.0 * Math.sin((x / 30.0) * pi)) *
            2.0) /
        3.0;
    return lon;
}
